"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBalMap = exports.clearBalancesCache = void 0;
let balMap = {};
function clearBalancesCache() {
    balMap = {};
}
exports.clearBalancesCache = clearBalancesCache;
function getBalMap() {
    return balMap;
}
exports.getBalMap = getBalMap;
